requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xQuickView', {
      sectionId: window.xQuickView.sectionId,
      videoScriptUrl: window.xQuickView.videoScriptUrl,
      videoScriptPromise: null,
      enabled: window.xQuickView.enabled,
      buttonLabel: window.xQuickView.buttonLabel,
      show_atc_button: window.xQuickView.show_atc_button,
      btn_atc_bottom: window.xQuickView.atc_btn_bottom,
      atc_btn_image_desktop: window.xQuickView.atc_btn_image_desktop,
      show: false,
      loading: false,
      currentVariant: '',
      cachedResults: {},
      cachedFetchPromises: {},
      activeProductUrl: '',
      renderedProductUrl: '',
      loadingUrls: [],
      loadedChooseOptions: [],
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      isMiniCart: false,
      buttonQuickView: "",
      listenerAdded: false,
      addListener() {
        if (this.listenerAdded) return;
        this.listenerAdded = true;

        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = {};
          this.renderedProductUrl = '';
        });

        document.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const trigger = event.target.closest('[data-quick-view-action]');
          if (!trigger) return;

          event.preventDefault();

          const action = trigger.dataset.quickViewAction;
          const productUrl = trigger.dataset.quickViewUrl;
          const optionId = trigger.dataset.quickViewOptionId;
          if (!action || !productUrl || !optionId) return;

          const component = Alpine.$data(trigger);

          if (action === 'choose-options') {
            if (component && 'showOptions' in component) {
              component.showOptions = !component.showOptions;
            }

            this.openChooseOptions(
              productUrl,
              trigger,
              optionId,
              Number(trigger.dataset.quickViewIndex) || 0
            );
            return;
          }

          if (action !== 'open-product') return;

          if (trigger.dataset.quickViewValidateBundle === 'true') {
            const validProduct = typeof component?.validateError !== 'function' || component.validateError(trigger);
            const validBundle = typeof component?.validateErrorAddAsBundle !== 'function' || component.validateErrorAddAsBundle(trigger);
            if (!validProduct || !validBundle) return;
          }

          this.openProduct(
            productUrl,
            trigger,
            optionId,
            trigger.dataset.quickViewMiniCart === 'true'
          );

          Alpine.store('xCustomerEvent')?.fire('product_selected', trigger);
        });
      },
      showBtn(enable, showATCButton, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },
      loadVideoScript() {
        if (this.videoScriptPromise) return this.videoScriptPromise;

        this.videoScriptPromise = new Promise((resolve) => {
          const existingScript = document.querySelector(`script[src="${this.videoScriptUrl}"]`);
          if (existingScript) {
            resolve();
            return;
          }

          const script = document.createElement('script');
          script.src = this.videoScriptUrl;
          script.onload = () => {
            script.dataset.loaded = 'true';
            resolve();
          };
          script.onerror = resolve;
          document.head.appendChild(script);
        });

        return this.videoScriptPromise;
      },
      async load(url, el, optionId) {
        this.buttonQuickView = el;

        const variant = document.getElementById('current-variant-' + optionId)?.innerText;
        let productUrl = variant ? `${url}?variant=${variant}&section_id=${this.sectionId}` : `${url}?section_id=${this.sectionId}`;
        productUrl = productUrl.replace(/\s+/g, '');
        this.activeProductUrl = productUrl;

        const destination = document.getElementById('quickview-product-content');
        if (!destination) return false;

        if (this.renderedProductUrl === productUrl && destination.innerHTML.trim() !== '') {
          this.loading = false;
          return true;
        }

        this.loading = true;

        try {
          let content = this.cachedResults[productUrl];

          if (!content) {
            if (!this.cachedFetchPromises[productUrl]) {
              const videoScriptReady = this.loadVideoScript();
              this.cachedFetchPromises[productUrl] = fetch(productUrl)
                .then((response) => {
                  if (!response.ok) throw new Error(`Quick View request failed: ${response.status}`);
                  return response.text();
                })
                .then(async (response) => {
                  const parsedDocument = new DOMParser().parseFromString(response, 'text/html');
                  const productContent = parsedDocument.getElementById('quickview-product-content');
                  if (!productContent) throw new Error('Quick View content was not found in the response');

                  await videoScriptReady;
                  this.cachedResults[productUrl] = productContent.innerHTML;
                  return this.cachedResults[productUrl];
                })
                .finally(() => {
                  delete this.cachedFetchPromises[productUrl];
                });
            }

            content = await this.cachedFetchPromises[productUrl];
          }

          if (this.activeProductUrl !== productUrl) return false;

          if (this.renderedProductUrl !== productUrl || destination.innerHTML.trim() === '') {
            destination.innerHTML = content;
            this.renderedProductUrl = productUrl;
          }

          return true;
        } catch (error) {
          console.error('Quick View failed to load', error);
          return false;
        } finally {
          if (this.activeProductUrl === productUrl) {
            this.loading = false;
          }
        }
      },
      async loadChooseOptions(url, el, optionId, index) {
        setTimeout(async () => { 
          let getVariant = document.getElementById('current-variant-' + optionId)?.innerText;
          let urlProduct = getVariant?`${url}?variant=${getVariant}&section_id=choose-option&page=${index}`:`${url}?section_id=choose-option&page=${index}`;
          
          let destinationElm = document.getElementById('choose-options-' + optionId)?.querySelector('.choose-options');
          let destinationElmMobile = document.getElementById('choose-options-mobile');
          let loadingEl = document.getElementById('choose-options-' + optionId)?.querySelector('.icon-loading');
          
          if (this.loadedChooseOptions[urlProduct]) {
            if (window.innerWidth > 767) {
              if (!el.closest('.card-product').querySelector('#choose-options-' + optionId)?.querySelector('.choose-options-content')) {
                destinationElm && (destinationElm.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElmMobile && (destinationElmMobile.innerHTML = '');  
              }
            } else {
              if (!el.closest('.card-product').querySelector('#choose-options-mobile')) {
                destinationElmMobile && (destinationElmMobile.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElm && (destinationElm.innerHTML = '');
              }
            }
            return true;
          }
          
          try {
            if (loadingEl) {
              loadingEl.classList.remove('hidden');
            }
            this.loadingChooseOption = true;
            if (!this.loadingUrls.includes(urlProduct)) {
              this.loadingUrls.push(urlProduct);
              await fetch(urlProduct).then((response) => response.text()).then((content) => {
                const parser = new DOMParser();
                const parsedContent = parser.parseFromString(content, 'text/html').getElementById("choose-options-content").innerHTML;
                
                if (parsedContent) {
                  if (window.innerWidth > 767) {
                    destinationElmMobile && (destinationElmMobile.innerHTML = '');
                    destinationElm && (destinationElm.innerHTML = parsedContent);
                  } else {
                    destinationElmMobile && (destinationElmMobile.innerHTML = parsedContent);
                    destinationElm && (destinationElm.innerHTML = '');
                  }
                  this.loadedChooseOptions[urlProduct] = parsedContent;
                }
                if (loadingEl) {
                  loadingEl.classList.add('hidden');
                }  
              }).finally(() => {
                const index = this.loadingUrls.indexOf(urlProduct);
                if (index !== -1) this.loadingUrls.splice(index, 1);  
                if (window.innerWidth > 767) {
                  if (destinationElm) {
                    if (destinationElm.querySelector(".add_to_cart_button")) {
                      destinationElm.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElm.querySelector(".label-btn-quickview")) {
                      destinationElm.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                } else {
                  if (destinationElmMobile) {
                    if (destinationElmMobile.querySelector(".add_to_cart_button")) {
                      destinationElmMobile.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElmMobile.querySelector(".label-btn-quickview")) {
                      destinationElmMobile.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                }      
              });
            }
            this.loadingChooseOption = false;
          } catch (error) {
            console.log(error);
          }
        }, 0)
      },
      openProduct(url, el, optionId, isMiniCart = false) {
        this.load(url, el, optionId);
        this.open(isMiniCart);
      },
      openChooseOptions(url, el, optionId, index) {
        this.loadChooseOptions(url, el, optionId, index);
        this.showChooseOption(optionId, el);
      },
      open(isMiniCart = false) {
        this.show = true;
        this.isMiniCart = isMiniCart;
        Alpine.store('xPopup').open = true;
      },
      close() {
        this.show = false;
        this.buttonQuickView = '';
        if(!Alpine.store('xMiniCart').open) {
          Alpine.store('xPopup').close();
        }
      },
      focusQuickView(quickView, btnClose) {
        if ( !this.selected ) { 
          Alpine.store('xFocusElement').trapFocus(quickView, btnClose);
        }
      },
      removeFocusQuickView() {
        if ( !this.selected ) { 
          const elementActive = document.getElementById("button_quickview");
          Alpine.store('xFocusElement').removeTrapFocus(elementActive);
        }
      },
      closePopupMobile() {
        this.openPopupMobile = false;
      },
      showChooseOption(id, el) {
        this.openPopupMobile = true;
        const product = el.closest(".card-product");
        const addToCartBtn = product.querySelector('.choose-options')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtn = product.querySelector('.choose-options')?.querySelector('.label-btn-quickview')
        const addToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.label-btn-quickview')

        if(addToCartBtn && iconAddToCartBtn && window.innerWidth > 767){
          addToCartBtn.style.display="block"
          iconAddToCartBtn.style.display="none"
        }else if(addToCartBtnMobile && iconAddToCartBtnMobile){
          addToCartBtnMobile.style.display="block"     
          iconAddToCartBtnMobile.style.display="none"
        }       
      },
      clickInsideQuickView(evt, $el) {
        if(this.isMiniCart) {
          evt.stopPropagation();
          this.show = false;
          Alpine.store('xPopup').close();
        }
      },
      clickInsideContentQuickView(evt) {
        evt.stopPropagation();
      }
    });

    Alpine.store('xQuickView').addListener();

  });
});
